import type { SportStats } from '@collector/sportsapi-types'

import type { DecimalFormat, PercentFormat } from './SportStatConfig'

export function isPercentFormat(
  format: PercentFormat | DecimalFormat,
): format is PercentFormat {
  return 'percent' in format
}

export function isDecimalFormat(
  format: PercentFormat | DecimalFormat,
): format is DecimalFormat {
  return 'decimal' in format
}

export function getStatisticInputDataType(
  sportStat: SportStats,
  format?: PercentFormat | DecimalFormat,
): NonNullable<SportStats['data_type']> | 'decimal' {
  if (format !== undefined && isDecimalFormat(format)) {
    return 'decimal'
  }
  return sportStat.data_type ?? 'integer'
}

export function getStatisticDecimalPlaces(
  format?: PercentFormat | DecimalFormat,
): number | undefined {
  if (format !== undefined && isDecimalFormat(format)) {
    return format.decimalPlaces
  }
  return undefined
}
